<template>
    <div class="form-control">
        <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
        <div class="flex">
            <select v-model="prefix" class="form-select w-auto shrink rounded-r-none border-r-0 bg-gray-50">
                <option v-for="option in prefixOptions" :key="option">{{ option }}</option>
            </select>
            <input v-model="domain" :class="{ error }" @change="domain = $event.target.value" type="text" class="form-input flex-1 rounded-l-none">
        </div>
        <small v-if="error" class="form-error">{{ error }}</small>
    </div>
</template>

<script setup>
import useId from '@/functions/id'
import { computed } from 'vue'
const props = defineProps({
    label: String,
    error: String,
    modelValue: {
        type: String,
        required: true,
    }
})

const emit = defineEmits(['update:modelValue'])

const prefixOptions = ['http://', 'https://']
const prefixRegex = /https?:\/\//g

const prefix = computed({
    get: () => prefixOptions.find(option => props.modelValue.startsWith(option)),
    set: value => emit('update:modelValue', `${value}${domain.value}`)
})

const domain = computed({
    get: () => props.modelValue.replace(prefixRegex, ''),
    set: value => {
        const matches = value.match(prefixRegex)
        if(matches) {
             return emit('update:modelValue', `${matches.slice(-1)}${value.replace(prefixRegex, '')}`)
        }
        emit('update:modelValue', `${prefix.value}${value}`)
    }
})

const id = useId(props.label)
</script>
